/**
 * @Author: Li, Yu Jia
 * @Date: 2020-04-27 15:49:16
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-12-18 16:13:32
 */

import React, { useCallback, useState } from 'react';
import { canSaveProject, getProjectData } from './../../../utils/selectors';
import { getAllowSaveProject, getCurrentStep, getIsAdminEditReorder, getSaveProjectData } from '../../selectors';
import { setBeforeUnloadListen, showWaitingCover, updateReturningUrl } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import SavedProjectConfirm from './../SavedProjectConfirm';
import { configuratorStep } from './../../constants';
import { getIsNextGenUI } from '../../../nextgen/selectors';
import { isMobileOnly } from 'react-device-detect';
import { modalType } from './../../../utils/constants';
import { objectDeepEqual } from '../../../utils';
import { setShowSaveProjectModal } from '../../../nextgen/actions';
import { showModal } from '../../../tools/actions';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { verifyAndSwitchSteps } from '../../logics';

const TopNavLink = ({ text, children, url, target = '_self', title, ...rest }) => {
  //variable
  const dispatch = useDispatch();
  const currentStep = useSelector(getCurrentStep);
  const allowSaveProject = useSelector(getAllowSaveProject);
  const csp = useSelector(canSaveProject);
  const projectData = useSelector(getProjectData);
  const oldProjectData = useSelector(getSaveProjectData);
  const isAdminEditReorder = useSelector(getIsAdminEditReorder);
  const isNextgen = useSelector(getIsNextGenUI);
  const [hasChangedProjectData, setHasChangedProjectData] = useState(false);
  const needToSave =
    allowSaveProject &&
    csp &&
    (isNextgen || currentStep === configuratorStep.canvas) &&
    (!oldProjectData.hasSavedProject || hasChangedProjectData) &&
    !isAdminEditReorder;

  //state
  //effect
  const [savedProjectConfirmShow, setSavedProjectConfirmShow] = useState(false);

  useDeepCompareEffect(() => {
    if (objectDeepEqual(oldProjectData.savedProjectData, projectData, null)) {
      setHasChangedProjectData(false);
    } else if (!hasChangedProjectData) {
      setHasChangedProjectData(true);
    }
  }, [oldProjectData, projectData]);

  // eslint-disable-next-line;
  const redirectAction = useCallback(() => {
    if (url !== '') {
      window.open(url, target);
    }
  }, [url, target]);

  const leaveWithoutSaveClickHandler = useCallback(() => {
    dispatch(setBeforeUnloadListen(false));
    dispatch(showWaitingCover());
    redirectAction(url);
  }, [dispatch, url, redirectAction]);

  const saveClickHandler = useCallback(() => {
    setSavedProjectConfirmShow(false);
    dispatch(updateReturningUrl(url));
    if (isNextgen) {
      dispatch(setShowSaveProjectModal(true));
    } else {
      isMobileOnly
        ? dispatch(verifyAndSwitchSteps({ nextStep: configuratorStep.mobileSaveProject }))
        : dispatch(showModal(modalType.SaveProject));
    }
  }, [dispatch, url, isNextgen]);

  const redirectLink = (url, e) => {
    dispatch(setBeforeUnloadListen(false));
    if (needToSave) {
      e.stopPropagation();
      setSavedProjectConfirmShow(true);
    } else {
      redirectAction(url);
    }
  };
  const savedProjectConfirmCloseHandler = () => {
    dispatch(setBeforeUnloadListen(true));
    setSavedProjectConfirmShow(false);
  };
  const outerHtml = children ? children : <>{text}</>;
  return (
    <>
      <a
        {...rest}
        href="#"
        onClick={(e) => {
          e.preventDefault();
          needToSave ? redirectLink(url, e) : window.open(url, target);
        }}
        title={title}>
        {outerHtml}
      </a>

      {needToSave && (
        <SavedProjectConfirm
          show={savedProjectConfirmShow}
          onClose={savedProjectConfirmCloseHandler}
          onLeave={leaveWithoutSaveClickHandler}
          onSave={saveClickHandler}
        />
      )}
    </>
  );
};

TopNavLink.propTypes = {
  text: PropTypes.string,
  url: PropTypes.string,
  target: PropTypes.string,
  title: PropTypes.string,
};

export default TopNavLink;
